import React, { ReactElement, useEffect, useState } from 'react';
import CircleProgressbar from './CircleProgressbar';
import { DeviceAttributes } from '../constants/telosair-interfaces';
import Button from '../controls/Button';
import DeviceSelect from './devices/DeviceSelect';

type AutoDetectionProps = {
  devices: DeviceAttributes[];
  onAddManual: () => void;
  onSave: () => void;
};

/**
 * A component to show detection progress of gateways.
 * @param props - AutoDetectionProps.
 * @returns - A Progress componet based on the detection time left.
 */
export default function AutoDetection(props: AutoDetectionProps): ReactElement {
  const { devices, onAddManual, onSave } = props;
  const [counter, setCounter] = React.useState(0);

  // remove later
  useEffect(() => {
    if (counter < 100) {
      setTimeout(() => setCounter(counter + 1), 50);
    }
  }, [counter]);
  const initialGateways = devices.map((device) => {
    return { ...device, active: false };
  });
  const [gateways, setGateways] = useState(initialGateways);
  return counter < 100 ? (
    <div>
      <CircleProgressbar percentage={counter} />
      <div className="pt-3 flex justify-center text-gray-300 dark:text-gray-300 text-xl">
        Gateway detection
      </div>
      <div className="pb-3 flex justify-center text-gray-500 dark:text-gray-400 text-base">
        Wait for X secs
      </div>
    </div>
  ) : (
    <div>
      <div className="mt-4">
        <span className="text-gray-500 text-sm font-medium">Our System Detected: </span>
        <span className="text-gray-300 text-sm font-medium"> 3 Gateways</span>
      </div>
      <div className="mt-4">
        {gateways?.map((device) => (
          <DeviceSelect
            key={device.id}
            isNotSelected={!!device.status}
            device={device}
            keepBordersalways
            handleSelect={(id, selectionStatus) => {
              setGateways(
                gateways?.map((dev) => {
                  if (dev.id === id) {
                    return { ...dev, active: !selectionStatus };
                  }
                  return dev;
                })
              );
            }}
          />
        ))}
      </div>
      <div className="my-8 pb-6 border-b border-b-gray-200 dark:border-b-gray-700">
        <Button theme="secondary-gray" size="sm" name="Add manually" onClick={onAddManual} />
      </div>
      <div className="mt-4">
        <Button theme="primary" size="sm" name="Save Changes" onClick={onSave} isBlockButton />
      </div>
    </div>
  );
}
